import React from "react";
import Context from "../../../../../context";

import {
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../components";
import "../index.scss";
import { useTranslation } from "react-i18next";

const SuperAgentInformation = () => {
  const { showModal, setShowModal, selectedCompany } = React.useContext(
    Context.CompanyScreen
  );

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"30vw"}
        maxWidth={"40vw"}
        open={showModal === "SHOW_MANAGER_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedCompany?.avatar}
            name={
              selectedCompany?.firstName
                ? selectedCompany?.firstName
                : selectedCompany?.name
            }
            lastName={
              selectedCompany?.lastName
                ? selectedCompany?.lastName
                : selectedCompany?.name
            }
            phoneNumber={
              selectedCompany?.phoneNumber
                ? selectedCompany?.phoneNumber
                : selectedCompany?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedCompany?.companyInformation?.nationalCode && (
              <CustomView.Column
                medium={5}
                small={12}
                large={8}
                className="form-values form-column"
              >
                <label className="form-label">{t("nationalCode")} :</label>
                <p>{selectedCompany?.companyInformation?.nationalCode}</p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default SuperAgentInformation;
